import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TimeRangeWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  width: 0;
  height: 0;
  margin-left: 0;
  left: ${props => props.procent}%;
  border-left: 2px solid ${props => props.theme.colors.secondary};
  border-right: 2px solid ${props => props.theme.colors.secondary};
  border-top: 26px solid ${props => props.theme.colors.secondary};
  pointer-events: none;
`;

function TimeRange({ procent }) {
  return <TimeRangeWrapper procent={procent} />;
}

TimeRange.propTypes = {
  procent: PropTypes.number.isRequired
};

export default TimeRange;
